// Module
var code = "<div class=\"one-line-text {{$ctrl.customClass}}\" title=\"{{$ctrl.content}}\" ng-show=\"$ctrl.content\" ng-bind=\"$ctrl.content\"></div> ";
// Exports
module.exports = code;